import { Controller } from "@hotwired/stimulus"
import {
  lockBodyScroll,
  unlockBodyScroll,
} from "~/controllers/mixins/useBodyScrollLock"

export default class extends Controller {
  static targets = ["dialog", "video"]

  open() {
    this.dialogTarget.showModal()
    lockBodyScroll()
    this.videoTarget.play().catch(() => {})
  }

  close() {
    this.dialogTarget.close()
  }

  // The backdrop is part of the dialog element, so a click that lands on the
  // dialog itself rather than its contents came from outside the player.
  closeOnBackdrop(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  // Fires however the dialog was dismissed, Escape included.
  reset() {
    this.videoTarget.pause()
    this.videoTarget.currentTime = 0
    unlockBodyScroll()
  }
}
